const hostname = window && window.location && window.location.hostname;
let apiUri = "localhost:3000";
let usuariosConvenios = "";
let usuariosContraloria = "";
let apiHomologador = '';

switch (hostname) {
  case "dev-arancel.isaprevidatres.cl": {
    apiUri = "https://dev-arancel-api.vidatres.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_DEV;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_DEV;
    apiHomologador = "https://dev-homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "qa-arancel.vidatres.cl": {
    apiUri = "https://qa-arancel-api.vidatres.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_QA;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_QA;
    apiHomologador = "https://qa-homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "arancel.vidatres.cl": {
    apiUri = "https://arancel-api.vidatres.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_PROD;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_PROD;
    apiHomologador = "https://homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "dev-arancel.isaprebanmedica.cl": {
    apiUri = "https://dev-arancel-api.banmedica.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_DEV;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_DEV;
    apiHomologador = "https://dev-homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "qa-arancel.banmedica.cl": {
    apiUri = "https://qa-arancel-api.banmedica.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_QA;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_QA;
    apiHomologador = "https://qa-homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "arancel.banmedica.cl": {
    apiUri = "https://arancel-api.banmedica.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_PROD;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_PROD;
    apiHomologador = "https://homologador-api.banmedica.cl/v1/solautomatica";
    break;
  }
  case "qa-arancel.apps.banmedica.cl": {
    apiUri = "http://qa-arancel-api.apps.banmedica.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_QA;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_QA;
    break;
  }
  default: {
    apiUri = "https://dev-arancel-api.banmedica.cl";
    //apiUri = "http://localhost:3000";
    // apiUri = "https://qa-arancel-api.banmedica.cl";
    usuariosConvenios = process.env.REACT_APP_BACKOFFICE_PERFIL_CONVENIOS_DEV;
    usuariosContraloria = process.env.REACT_APP_BACKOFFICE_PERFIL_CONTRALORIA_DEV;
    apiHomologador = "https://dev-homologador-api.banmedica.cl/v1/solautomatica";
  }
}

const config = {
  apiUri,
  usuariosConvenios,
  usuariosContraloria,
  apiHomologador,
};

export default config;




// WEBPACK FOOTER //
// ./src/config/api.js